import React, { useState } from 'react'
import styled from 'styled-components'
import SignatureIcon from '../icons/signature'
import Modal from '../../../common/Modal'
import {
  PrepareEsignModal,
  RequestSentModal,
  EsignUrlModal,
} from '../../modals'

const ButtonElement = styled.button`
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #2e8ab8;
  border-radius: 4px;
  padding: 0.5rem 1.5rem;
  gap: 0.5rem;
  color: #2e8ab8;
  cursor: pointer;
  width: 70%;
  margin-left: auto;

  &:hover {
    background-color: rgba(25, 118, 210, 0.04);
  }
`

const TextElement = styled.p`
  margin: 0;
  font-weight: 200;
`

function PrepareEsign({ loanId, document, guarantors, showBlueBar }) {
  const [showPrepareEsignModal, setShowPrepareEsignModal] = useState(false)
  const [showRequestSentModal, setShowRequestSentModal] = useState(false)
  const [showEsignUrlModal, setShowEsignUrlModal] = useState(false)

  return (
    <>
      {!showBlueBar && (
        <ButtonElement onClick={() => setShowPrepareEsignModal(true)}>
          <SignatureIcon />
          <TextElement>Prepare for eSign</TextElement>
        </ButtonElement>
      )}
      <Modal top light isModalOpen={showPrepareEsignModal}>
        <PrepareEsignModal
          toggleModal={() => setShowPrepareEsignModal(false)}
          toggleRequestSentModal={() => setShowRequestSentModal(true)}
          toggleEsignUrlModal={() => setShowEsignUrlModal(true)}
          document={document}
          loanId={loanId}
          guarantors={guarantors}
        />
      </Modal>
      <Modal light isModalOpen={showRequestSentModal}>
        <RequestSentModal toggleModal={() => setShowRequestSentModal(false)} />
      </Modal>
      {/* for some reason this is using the first guarantor only */}
      {guarantors?.length >= 1 && (
        <Modal light isModalOpen={showEsignUrlModal}>
          <EsignUrlModal
            toggleModal={() => setShowEsignUrlModal(false)}
            document={document}
            guarantor={guarantors[0]}
          />
        </Modal>
      )}
    </>
  )
}

export default PrepareEsign
